import React, { Component, useCallback } from 'react'
import { sagaModal } from 'redux-saga-modal'
import { Form, Modal, Input, Col, Row, Button, message, Radio } from 'antd'
import * as actions from '@/models/banner/services'
import * as services from '@/models/banner/services';
import Upload from '../CreateOrderDialog/Upload';
import styles from './style.module.scss'
import dayjs from 'dayjs';
const { TextArea } = Input;

@Form.create()
class BannerDialog extends Component {
  state = {
    loading: false,
  }

  handleSubmit = e => {
    const { banner = {}, submitCallback, onSuccess } = this.props
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      console.log(11111111, values)
      if (err) {
        return console.error(err)
      }
      const datas = { ...values, image: values.image[0].url }
      console.log(datas)
      // return
      this.setState({ loading: true })

      if (!banner._id) {
        services.addBanner(datas).then(result => {
          message.success('添加成功')
          // this.props.form.resetFields()
          onSuccess(result)
          submitCallback && submitCallback()
        }).catch(err => {
          message.error(err.message || '发生错误')
        }).finally(() => {
          this.setState({
            loading: false
          })
        })
      } else {
        services.updateBanner({
          id: banner._id,
          ...datas
        }).then(result => {
          message.success('修改成功')
          // this.props.form.resetFields()
          onSuccess(result)
          submitCallback && submitCallback()
        }).catch(err => {
          message.error(err.message || '发生错误')
        }).finally(() => {
          this.setState({
            loading: false
          })
        })
      }
    });
  }
  componentDidMount() {

  }

  render() {
    const { banner = {}, disabled } = this.props
    const { getFieldDecorator } = this.props.form
    //const disabled = this.state.loading
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    }
    return (
      <div>
        <Form {...formItemLayout} onSubmit={this.handleSubmit}>
          <Row>
            <Col span={24}>
              <Form.Item
                label="标题"
              >
                {getFieldDecorator('title', {
                  initialValue: banner.title,
                  rules: [
                    { required: true, message: '请输入标题', },
                  ],
                })(
                  <Input placeholder="请输入标题" />
                )}
              </Form.Item>

              <Form.Item
                label="跳转地址"
              >
                {getFieldDecorator('url', {
                  initialValue: banner.url,
                  rules: [
                    { message: '请输入跳转地址', },
                  ],
                })(
                  <Input placeholder="请输入跳转地址" />
                )}
              </Form.Item>
              <Form.Item label="图片">
                {getFieldDecorator('image', {
                  initialValue: banner?.image,
                  rules: [
                    { required: true, message: '请上传图片', },
                  ],
                })(<Upload max={1} />)}
              </Form.Item>
              <Form.Item
                label="类型"
              >
                {getFieldDecorator('type', {
                  initialValue: banner.type || 1,
                  rules: [
                    { required: true, message: '请选择类型', },
                  ],
                })(
                  <Radio.Group>
                    <Radio value={1}>小程序首页</Radio>
                  </Radio.Group>
                )}
              </Form.Item>
              <Form.Item
                label="状态"
              >
                {getFieldDecorator('status', {
                  initialValue: banner.status === false?false:true,
                  rules: [
                    { required: true, message: '请选择状态', },
                  ],
                })(
                  <Radio.Group>
                    <Radio value={true}>上架</Radio>
                    <Radio value={false}>下架</Radio>
                  </Radio.Group>
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col style={{ textAlign: "center" }}>
              <Button type="primary" disabled={disabled} htmlType="submit">保存消息</Button>
            </Col>
          </Row>
        </Form>
      </div>
    )
  }
}

const BannerInfoDialog = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title={ownProps.title}
    destroyOnClose
    footer={null}
    width={600}
    visible={isOpen}
    onCancel={hide}>
    <BannerDialog onSuccess={hide} {...ownProps} />
  </Modal>
)

export default sagaModal({
  name: 'BANNER_DIALOG',
})(BannerInfoDialog)
